import { ReplaySubject } from 'rxjs';

export abstract class BaseComponent {
  readonly destroyed$: ReplaySubject<void> = new ReplaySubject();

  destroy(): void {
    if (this.destroyed$) {
      this.destroyed$.next();
      this.destroyed$.complete();
    }
  }
}
